<template>
  <div class="page-header">
    <div class="main-box">
      <div class="logo">
        <!-- <router-link :to="'/result'"><div class="pic"></div></router-link> -->
        <router-link :to="'/result'">  <div class="txt">
          <router-link :to="isHome ? '/result' : '/home'">
            <i :class="isHome ? 'list' : 'home'"></i
            >{{ isHome ? "常规视图" : "地图视图" }}
            <i class="more"></i>
          </router-link>
        </div></router-link>
      </div>
      <div class="search-ipt">
        <div class="ipt-box">
          <input
            v-model="keywordModel"
            placeholder="请输入关键词检索"
            type="text"
            @keydown.enter="handleSearch"
          />
          <a class="sch-btn" href="javascript:" @click="handleSearch"></a>
        </div>
        <div class="type-filter">
          <div class="check-box" @click="handleSelect('', true)">
            <div :class="checkAll ? 'ck cur' : 'ck'">
              <i></i>
            </div>
            全部
          </div>
          <template v-for="o in typeDict">
            <div :key="o.id" class="check-box" @click="handleSelect(o.id)">
              <div
                :class="
                  typeModelSave.search(o.id.toString()) > -1 ? 'ck cur' : 'ck'
                "
              >
                <i></i>
              </div>
              {{ o.typeName }}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { queryData } from "@/api";

export default {
  data() {
    return {
      keywordModel: "",
      typeModelSave: "1,2,3,4,5,6,7,8",
      isMobile: document.documentElement.clientWidth <= 840,
      slideToggle: false,
      checkAll: true,
    };
  },
  computed: {
    ...mapState({
      typeModel: (state) => state.control.typeModel,
      keyword: (state) => state.control.keyword,
      typeDict: (state) => state.control.typeDict,
      searchCount: (state) => state.control.searchCount,
    }),
    isHome() {
      return this.$route.name === "home";
    },
  },
  watch: {
    typeModel() {
      const arr = this.typeModel.split(",");
      this.typeModelSave = this.typeModel;
      this.checkAll = arr.length === this.typeDict.length;
    },
  },
  mounted() {
    this.eventInit();
    this.query();
  },
  methods: {
    async query() {
      const res = await queryData("typeList");
      const ids = res.data.map((i) => {
        return i.id;
      });
      this.$store.commit("control/SET_typeDict", res.data);
      this.$store.commit("control/SET_typeModel", ids.join(","));
    },
    handleSelect(key, flag) {
      let typeModel = "";
      if (flag) {
        this.checkAll = !this.checkAll;
        if (this.checkAll) {
          typeModel = this.typeDict
            .map((i) => {
              return i.id;
            })
            .join(",");
        } else {
          typeModel = "";
        }
      } else {
        key = key.toString();
        const arr = this.typeModelSave.split(",");
        if (arr.includes(key)) {
          arr.splice(arr.indexOf(key), 1);
        } else {
          arr.push(key);
        }
        this.checkAll = arr.length === this.typeDict.length;
        typeModel = arr.join(",");
      }
      this.typeModelSave = typeModel;
    },
    eventInit() {
      window.addEventListener("resize", this.setIsMobile);
      document.body.addEventListener("click", this.hideSlide);
    },
    setIsMobile() {
      this.isMobile = document.documentElement.clientWidth <= 840;
    },
    hideSlide() {
      this.slideToggle = false;
    },
    handleSearch() {
      this.$store.commit("control/SET_typeModel", this.typeModelSave);
      this.$store.commit("control/SET_keyword", this.keywordModel);
      this.$store.commit("control/SET_searchCount", this.searchCount + 1);
      this.keywordModel = "";
      if (this.$route.name !== "result") {
        this.$router.push({ name: "result" });
      }
    },
  },
};
// 百度统计 begin
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?ed8e985596f281fdcd4d90a45a228a01";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
// 百度统计 end
</script>
